import { connect } from 'react-redux';

import { userManagementActions } from "dataflow/distributorPortal/actions";

import { UserListPresentation } from './UserListPresentation';

function mapStateToProps(state) {
    const { 
        getUserList_requesting, getUserList_status, 
        userList, userListHeaders,

        getUserGroupList_requesting, getUserGroupList_status,
        userGroupList,

        addUser_requesting, addUser_status,
        addUser_errorMsg,

        updateUser_requesting, updateUser_status,
        updateUser_errorMsg,

        deleteUser_requesting, deleteUser_status,
        deleteUser_errorMsg,

        addUserGroupMapping_requesting, addUserGroupMapping_status,
        addUserGroupMapping_errorMsg,

        removeUserGroupMapping_requesting, removeUserGroupMapping_status,
        removeUserGroupMapping_errorMsg,

        isUserRecordUpdatedSuccessfully,
        totalRequests,

        userPermissions
    } = state.distributorPortal_userManagementReducers;
    
	return {
        getUserList_requesting, getUserList_status, 
        userList, userListHeaders,

        getUserGroupList_requesting, getUserGroupList_status,
        userGroupList,

        addUser_requesting, addUser_status,
        addUser_errorMsg,
        
        updateUser_requesting, updateUser_status,
        updateUser_errorMsg,

        deleteUser_requesting, deleteUser_status,
        deleteUser_errorMsg,

        addUserGroupMapping_requesting, addUserGroupMapping_status,
        addUserGroupMapping_errorMsg,

        removeUserGroupMapping_requesting, removeUserGroupMapping_status,
        removeUserGroupMapping_errorMsg,

        isUserRecordUpdatedSuccessfully,
        totalRequests,

        userPermissions
    };
}

function mapDispatchToProps(dispatch) {
    return {
        getList: (pageNo, pageSize, sort, filterOptions) => { dispatch(userManagementActions.getUserList(pageNo, pageSize, sort, filterOptions)); },
        getUserGroupList: () => { dispatch(userManagementActions.getUserGroupList()); },

        deleteUser: (userId) => { dispatch(userManagementActions.deleteUser(userId)); },

        addUserGroupMapping: (userInfo) => { dispatch(userManagementActions.addUserGroupMapping(userInfo)); },
        removeUserGroupMapping: (userGroupId) => { dispatch(userManagementActions.removeUserGroupMapping(userGroupId)); },
    };
}

const UserList = connect(mapStateToProps, mapDispatchToProps)(UserListPresentation);

export default UserList;